import { SummaryType } from '@ls/grouping-service';
import { exchange } from '@ls/js-fetch';
import scope from 'state/analytics/scope';
import SelectionState from 'state/selections/SelectionState';
import { selectGetGroupingParams, selectSecurityLabel, selectSideBySideValue, selectScenarioValue } from 'state/selections/selectors';

export const SET_GRID_INSTANCE = 'grid/SET_GRID_INSTANCE';
export const setGridInstance = (gridInstance) => ({
  type: SET_GRID_INSTANCE,
  gridInstance,
});

export const SET_GRID_ID_NAME = 'grid/SET_GRID_ID_NAME';
export const setGridStateId = gridStateName => ({
  type: SET_GRID_ID_NAME,
  gridStateName
});

export const REQUEST_BASE_DATA = `${scope}/REQUEST_BASE_DATA`;
export const RECEIVE_BASE_DATA = `${scope}/RECEIVE_BASE_DATA`;
export const REQUEST_BASE_SBS_DATA = `${scope}/REQUEST_BASE_SBS_DATA`;
export const RECEIVE_BASE_SBS_DATA = `${scope}/RECEIVE_BASE_SBS_DATA`;

export const requestBaseGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
    // add in the security attribute for the label, if one is selected
    const securityLabel = selectSecurityLabel(SelectionState.COMMITTED)(state);
    const securityAttributes = ['name', 'bbShortName', 'defaultSecId', 'cusip', 'defaultSecurityId', 'gpsId', 'isin'];
    if (securityLabel?.length > 0) {
      securityAttributes.push(securityLabel);
    }
    dispatch({ type: REQUEST_BASE_DATA });
    dispatch({
      type: RECEIVE_BASE_DATA,
      data: (await exchange({
        params: getGroupingParams({
          summary: SummaryType.RELATIVE,
          benchesToo: true,
          results: ['SECURITY_ATTRIBUTES'],
          security_attributes: securityAttributes,
          meta_data: "ALL",
        }),
        cancelId: `data-${scope}`,
        url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
      }))?.data,
    });
  };
};

export const requestBaseSbsGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);
    const scenarioValue = selectScenarioValue(SelectionState.COMMITTED)(state);
    const sideBySideValue = selectSideBySideValue(SelectionState.COMMITTED)(state)
    // add in the security attribute for the label, if one is selected
    const securityLabel = selectSecurityLabel(SelectionState.COMMITTED)(state);
    const securityAttributes = ['name', 'bbShortName', 'defaultSecId', 'cusip', 'defaultSecurityId', 'gpsId', 'isin'];
    if (securityLabel?.length > 0) {
      securityAttributes.push(securityLabel);
    }
    let params = getGroupingParams({
      summary: SummaryType.RELATIVE,
      benchesToo: true,
      results: ['SECURITY_ATTRIBUTES'],
      security_attributes: securityAttributes,
      meta_data: "ALL",
    });
    if (!!scenarioValue && !!sideBySideValue) {
      params = { ...params, workspace: scenarioValue }
    }
    dispatch({ type: REQUEST_BASE_SBS_DATA });
    dispatch({
      type: RECEIVE_BASE_SBS_DATA,
      data: (await exchange({
        params,
        cancelId: `data-${scope}`,
        url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
      }))?.data,
    });
  };
};
